import { orderReadyForShipment } from '../../../../utils/stockQuantities';
export const norm = (v) => (v == null ? '' : String(v).trim());

/** Кнопку збірки сканером показуємо лише доки замовлення ще не «пішло» з процесу відправки. */
const SCANNER_PICK_HIDE_BUTTON_STATUSES = new Set(['SENT', 'RETURNED', 'CANCELLED']);

export function isScannerPickButtonAvailable(order) {
  const db = order?.orderStatus?.databaseValue;
  return orderReadyForShipment(order) && !SCANNER_PICK_HIDE_BUTTON_STATUSES.has(db);
}

export function codesMatch(item, scanned) {
  const c = norm(scanned);
  if (!c) return false;
  const bc = norm(item.barcode);
  const pc = norm(item.productCode);
  if (bc && bc === c) return true;
  if (pc && pc === c) return true;
  return false;
}

export function lineQty(item) {
  const q = item.quantity;
  const n = typeof q === 'number' ? q : parseInt(q, 10);
  if (!Number.isFinite(n) || n < 1) return 1;
  return n;
}

/** Колір фону рядка / картки за прогресом сканування */
export function pickRowBackground(index, items, scannedCounts) {
  const need = lineQty(items[index]);
  const got = scannedCounts[index] || 0;
  if (got === 0) return '#ffffff';
  if (got >= need) return '#d4edda';
  return '#fff3cd';
}

/** Акцент зліва для карток на мобільному */
export function pickCardAccentBorder(index, items, scannedCounts) {
  const need = lineQty(items[index]);
  const got = scannedCounts[index] || 0;
  if (got === 0) return '#dee2e6';
  if (got >= need) return '#28a745';
  return '#ffc107';
}

/**
 * Вибір товару з відповіді search-info (як при прив’язці на поставках): точний штрихкод / артикул, інакше єдиний результат.
 */
/** Головне фото позиції замовлення (sortOrder 0), як на сторінці замовлення. */
export function getPrimaryImagePathFromOrderItem(item) {
  if (!item?.images?.length) return null;
  const primary = item.images.find((img) => img.sortOrder === 0) || item.images[0];
  return primary?.imagePath || null;
}

export function pickProductFromSearchResults(products, scannedCode) {
  const c = norm(scannedCode);
  if (!c || !products?.length) return null;
  const byBarcode = products.find((p) => norm(p.barcode) === c);
  if (byBarcode) return byBarcode;
  const byCode = products.find((p) => norm(p.code) === c);
  if (byCode) return byCode;
  if (products.length === 1) return products[0];
  return null;
}
